import { cva, type VariantProps } from "class-variance-authority"

export const buttonVariants = cva(
  "box-border flex justify-center items-center py-2 rounded font-medium focus:outline-none focus:ring-4 focus:ring-inset disabled:cursor-not-allowed",
  {
    variants: {
      size: {
        medium: "px-4 text-xs sm:text-sm leading-6",
        large: "px-6 leading-8",
      },
      variant: {
        primary:
          "border border-blue-30-primary hover:border-blue-40 bg-blue-30-primary hover:bg-blue-40 text-white active:bg-blue-50 focus:ring-blue-20 disabled:bg-neutral-10-background disabled:text-neutral-35 disabled:border-neutral-10-background disabled:hover:bg-neutral-10-background disabled:hover:border-neutral-10-background",
        secondary:
          "bg-white border border-neutral-20 text-blue-30-primary hover:border-blue-30-primary active:text-blue-40 active:border-blue-40 focus:ring-blue-20 disabled:bg-white disabled:text-neutral-35 disabled:border-neutral-20",
      },
      fullWidth: {
        true: "w-full",
        false: "w-fit",
      },
    },
    defaultVariants: {
      size: "medium",
      variant: "primary",
      fullWidth: false,
    },
  },
)

export type ButtonVariantProps = VariantProps<typeof buttonVariants>
